package com.trevorwiebe.timesheet.calendar.presentation.composables

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.trevorwiebe.timesheet.calendar.presentation.uiHelper.TimeOffRequestUi
import com.trevorwiebe.timesheet.core.domain.Util
import com.trevorwiebe.timesheet.theme.successGreenBackground
import com.trevorwiebe.timesheet.theme.successGreenText

@Composable
fun DayListEventItem(
    timeOffRequestModel: TimeOffRequestUi,
    approved: Boolean?,
    onClick: () -> Unit,
) {

    val backgroundColor = if (approved == true) successGreenBackground else if(approved == false) MaterialTheme.colorScheme.errorContainer else MaterialTheme.colorScheme.background
    val textColor = if (approved == true) successGreenText else if (approved == false) MaterialTheme.colorScheme.onErrorContainer else MaterialTheme.colorScheme.onBackground

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(6.dp)
            .clickable(onClick = onClick)
            .clip(RoundedCornerShape(6.dp))
            .background(backgroundColor)
            .padding(8.dp)
    ) {
        Text(
            text = timeOffRequestModel.employeeName ?: "",
            fontSize = 16.sp,
            modifier = Modifier,
            maxLines = 1,
            color = textColor,
            overflow = TextOverflow.Ellipsis,
            fontWeight = FontWeight.Bold
        )
        if (approved != null) {
            val reviewedDate =
                remember { "Reviewed on: ${Util.toFriendlyDate(timeOffRequestModel.request.reviewedDate)}" }
            Text(
                text = reviewedDate,
                fontSize = 14.sp,
                modifier = Modifier,
                maxLines = 1,
                color = textColor,
                overflow = TextOverflow.Ellipsis
            )
        }else{
            Text(
                text = "Not reviewed yet",
                fontSize = 14.sp,
                modifier = Modifier,
                maxLines = 1,
                color = textColor,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}